import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mixins from './mixins'
import * as echarts from "echarts"
import 'lib-flexible/flexible.js'
import "@/assets/text/text.css";
// 解析数学表达式
// import mathJax from './util/MathJax'; // 引入样式
import countTo from 'vue-count-to';
import noData from './components/noData.vue'

import directive from "./util/directive";
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)
Vue.directive('copy', directive.copy);

Vue.mixin(mixins)
// 配置element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

Vue.component('countTo',countTo)
Vue.component('noData',noData)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false


// Vue.prototype.$mathJax = mathJax;

if (process.env.NODE_ENV !== 'development') { // 运行环境判断；生产环境不输出log日志
  console.log = function () {}
  console.error = function(){}
  console.dir = function(){}
  console.warn = function(){}
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
